import DutyIcon from '@icons/custom/duty.svg';
import LeadIcon from '@icons/custom/lead-icon.svg';
import PriceListIcon from '@icons/custom/price-list.svg';
import PricingCatalogIcon from '@icons/custom/pricing-catalog.svg';
import ProductParameterIcon from '@icons/custom/product-parameter.svg';
import RuleIcon from '@icons/custom/rules-icon.svg';
import ScoutingIcon from '@icons/custom/scouting-icon.svg';
import SpecificationItemProductIcon from '@icons/custom/specification-item-product.svg';
import SupplierIcon from '@icons/custom/supplier-icon.svg';
import { SVG } from '@web/shared/components/svg-icon/svg-icon.types';
import { NavBackStackEntry } from './nav-back-stack.types';

export interface NavBackMenuVisual {
  /** CSS variable name, including the leading dashes. */
  color: string;
  primeIcon?: string;
  svg?: SVG;
}

const SECTION_VISUALS: Record<string, NavBackMenuVisual> = {
  dashboard: { color: '--color-soe-dark-gray-500', primeIcon: 'pi pi-th-large' },
  contacts: { color: '--color-soe-twilight-blue', primeIcon: 'pi pi-address-book' },
  'real-estates': { color: '--color-soe-orange-glow', primeIcon: 'pi pi-building' },
  leads: { color: '--color-soe-tropical-green', svg: LeadIcon },
  scoutings: { color: '--color-soe-golden-sand', svg: ScoutingIcon },
  scheduler: { color: '--color-soe-blue-steel', primeIcon: 'pi pi-calendar' },
  todo: { color: '--color-soe-plum', primeIcon: 'pi pi-list-check' },
  rules: { color: '--color-soe-dusk-indigo', svg: RuleIcon },
  suppliers: { color: '--color-soe-ocean-blue', svg: SupplierIcon },
  'suppliers-documents': { color: '--color-soe-ocean-blue', primeIcon: 'pi pi-file' },
  'employees-owner': { color: '--color-soe-orchid-purple', primeIcon: 'pi pi-id-card' },
  'employees-suppliers': { color: '--color-soe-orchid-purple', primeIcon: 'pi pi-id-card' },
  employees: { color: '--color-soe-orchid-purple', primeIcon: 'pi pi-id-card' },
  'owner-company': { color: '--color-soe-ocean-blue', primeIcon: 'pi pi-briefcase' },
  'owner-company-documents': { color: '--color-soe-ocean-blue', primeIcon: 'pi pi-file' },
  certifications: { color: '--color-soe-ocean-blue', primeIcon: 'pi pi-verified' },
  'membership-users': { color: '--color-soe-dusk-indigo', primeIcon: 'pi pi-users' },
  'sales-resources': { color: '--color-soe-olive-green', svg: ProductParameterIcon },
  'sales-price-lists': { color: '--color-soe-petrol-blue', svg: PriceListIcon },
  'sales-pricing-catalogs': { color: '--color-soe-blue-steel', svg: PricingCatalogIcon },
  'sales-products': { color: '--color-soe-royal-blue', svg: SpecificationItemProductIcon },
  'sales-duties': { color: '--color-soe-deep-teal', svg: DutyIcon },
  sales: { color: '--color-soe-olive-green', svg: ProductParameterIcon },
  'biddings-bids': { color: '--color-soe-petrol-blue', svg: ProductParameterIcon },
  'biddings-quotations': { color: '--color-soe-petrol-blue', svg: ProductParameterIcon },
  'biddings-metric-computations': { color: '--color-soe-petrol-blue', svg: ProductParameterIcon },
  biddings: { color: '--color-soe-petrol-blue', svg: ProductParameterIcon },
  projects: { color: '--color-soe-sage-mist', primeIcon: 'pi pi-file-check' },
  'construction-sites': { color: '--color-soe-brick-clay', primeIcon: 'pi pi-hammer' },
};

const FALLBACK_VISUAL: NavBackMenuVisual = {
  color: '--color-soe-dark-gray-400',
  primeIcon: 'pi pi-circle-fill',
};

export function navBackMenuVisual(entry: NavBackStackEntry): NavBackMenuVisual {
  if (entry.kind === 'dashboard') {
    return SECTION_VISUALS['dashboard'];
  }

  const visual = SECTION_VISUALS[entry.featureKey] ?? FALLBACK_VISUAL;
  if (entry.kind === 'list' && (entry.view === 'map' || entry.lastTab === 'map')) {
    return { color: visual.color, primeIcon: 'pi pi-map' };
  }
  return visual;
}

export function navBackMenuAccent(entry: NavBackStackEntry): string {
  return `var(${navBackMenuVisual(entry).color})`;
}
